/**
 * Canonical NZ SEGMENT configuration.
 * All other SEGMENT-related lookups are derived from this single source.
 */
export const SEGMENTS = {
  centrr:   { name: "Pragmatic Centrists", shortLabel: "Centrists",   color: "#999999", field: "PragCentre_n" , description:"Moderate and solutions-focused; lean soft-left on environment and fairness but wary of extremes."  },
  idealists:   { name: "Progressive Idealists",   shortLabel: "Progressive",   color: "#009E73", field: "ProgIdeal_n" , description:"Left-wing, pro-diversity, climate-driven and reform-minded; believe in social change but doubt politics delivers it." },
  disillusioned:   { name: "Disillusioned",      shortLabel: "Disillusioned",   color: "#D55E00", field: "Disillusioned_n", description:"Slightly right-leaning, tax-averse, and sceptical of politicians; feel the system serves elites, not voters."  },
  populist: { name: "Populist Right",    shortLabel: "Populist", color: "#E69F00", field: "PopRight_n", description:"Hard-right, nationalist and anti-elite; tough on crime and immigration, sceptical of climate costs and political motives." },
  traditionalists:   { name: "Law-and-Order Traditionalists",      shortLabel: "Traditionalists",   color: "#0072B2", field: "Trads_n", description:"Socially conservative and tough-on-crime; trust institutions and value order, stability and discipline." },
};


/** Coalition colour — used wherever the right coalition is shown as a single entity */
export const COALITION_COLOR = "#1B4F8A";

/** { "nat_pred_n": { name, color }, ..., coalition: { name, color } } — for map/grid components */
export const SEGMENT_INFO = {
  ...Object.fromEntries(
    Object.values(SEGMENTS).map(({ name, color, field, description }) => [field, { name, color, description }])
  )
};

/** { nat: "#0056A8", ... } — for components using short keys */
export const SEGMENT_COLOURS = Object.fromEntries(
  Object.entries(SEGMENTS).map(([k, { color }]) => [k, color])
);

/** { National: "#0056A8", ... } — for components using display-name keys */
export const SEGMENT_COLOURS_BY_NAME = Object.fromEntries(
  Object.values(SEGMENTS).map(({ name, color }) => [name, color])
);

/** { National: "nat_pred_n", ... } — for VoteLineCharts / NationalVoteBar field lookups */
export const SEGMENT_FIELDS_BY_NAME = Object.fromEntries(
  Object.values(SEGMENTS).map(({ name, field }) => [name, field])
);

/** { "nat_pred_n": "past_vote_nat", ... } — for VotersSeats past-vote heat map */
export const PAST_VOTE_MAP = Object.fromEntries(
  Object.values(SEGMENTS).map(({ field, pastVoteField }) => [field, pastVoteField])
);

/** Ordered list for scatter/arrow comparison controls (excludes Other) */
export const COMPARE_SEGMENT_OPTIONS = Object.entries(SEGMENTS)
  .filter(([k]) => k !== "oth")
  .map(([, { shortLabel: label, color, field: key }]) => ({ key, label, color }));

/** Derive { labels, colors } maps from any SEGMENT_INFO-shaped object */
export function buildLabelsAndColors(info = SEGMENT_INFO) {
  const labels = {};
  const colors = {};
  Object.entries(info).forEach(([key, { name, color }]) => {
    labels[key] = name;
    colors[key] = color;
  });
  return { labels, colors };
}
